export const OPEN_LOCATION_MODAL = 'OPEN_LOCATION_MODAL';
export const CLOSE_LOCATION_MODAL = 'CLOSE_LOCATION_MODAL';
export const TOGGLE_GEOFENCE_SETTINGS = 'TOGGLE_GEOFENCE_SETTINGS';
export const FETCH_GEOLOCATION = 'FETCH_GEOLOCATION';
export const ADD_LOCATION_OPTION = 'ADD_LOCATION_OPTION';
export const REMOVE_LOCATION_OPTION = 'REMOVE_LOCATION_OPTION';
export const LOAD_GEOFENCE_SETTINGS = 'LOAD_GEOFENCE_SETTINGS';
export const SET_INPUT_VALUE = 'SET_INPUT_VALUE';
